import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, downloadAsPdf, handleShare, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import html2pdf from 'html2pdf.js';
import { useRef } from 'react';
import PaymentDrawyer from "./DrawyerPages/PaymentDrawyer";
import { useForm } from "react-hook-form";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
export const OverViewQuotation: React.FC<any> = React.memo((props) => {
  const isMobile = IsSmallScreen();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getQuotationPermission;
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
  const navigate = useNavigate();
  const params = useParams();
  const [quotationData, setQuotationData] = useState<any>([])
  const id = params?.id;
  const [resetLoad, setResetLoad] = useState(false)
  const hiddenRef = useRef<HTMLDivElement>(null);
  const [htmlContent, setHtmlContent] = useState('');
  const [openF, setOpen] = React.useState(false);
  const [formComponent, setFormComponent] = useState<any>()
  const { control, register, handleSubmit, setValue, reset } = useForm();
  useEffect(() => {
    const getQuotations = async () => {
      try {
        setResetLoad(false);
        const response: any = await callAPI(`quotations/lead/${id}`, Method.GET, null, null);
        const sortedData = (response?.data || []).sort(
          (a: any, b: any) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        );
        setQuotationData(sortedData);
      } catch (e) {
        console.error("Error fetching quotations:", e);
      }
    };
    getQuotations();
  }, [resetLoad]);

  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "customerName",
      tooltip: true,
      type: 'default'
    },
    {
      header: "No",
      fieldName: "quotationNumber",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Expiry",
      fieldName: "validTill",
      tooltip: true,
      isHide: isMobile,
      type: 'date'
    },
    {
      header: "Total",
      fieldName: "grandTotal",
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, 'Convert to Order', "Print", remove ? "Delete" : undefined, "Share"].filter(Boolean), //"Convert to Order"
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const handleDelete = async (id?: string | number) => {
      setResetLoad(false)
    const response: any = await callAPI(`quotations`, Method.DELETE, null, id);
    dispatch(resetDataComponent('quotationGrid'));
      setResetLoad(true)
  
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };


  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`quatation/${row?.id}`)
    }
    else if (action === "Print") {
      navigate(`/quatation/print/${row?.id}`);
    }
    else if (action === 'Convert to Order') {
      navigate(`order/convert-order/${row?.id}`);

    } else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }
    else if (action === 'Share') {

      handleShare(`/quatation/print/${row.id}`, 'Quotation');
    } else if (action === 'Payment') {

      const totalIncludedAmount = row?.quotationItems
        ?.filter((item: any) => item.isIncluded)
        .reduce((sum: number, item: any) => sum + Number(item.totalPrice || 0), 0);
      const advanceAmount: any = (totalIncludedAmount * 30) / 100;
      const qData: any = { ...row, ...{ amountReceived: advanceAmount } };
      const form: any = <PaymentDrawyer
        id="paymentrawyer"
        data={qData}
        //paymentId={row?.id}
        control={control}
        quatationId={row?.id}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    }

  }
  const handleQuotationAddClick = () => {
    navigate(`quatation`)
  }
  const handlePaymentData = async (data: any) => {
    try {
      dispatch(storeDataComponent('paymentSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        reset()
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('paymentDealsGrid'));
        setResetLoad(true)
        showMessage('Product Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(false)
    }
    finally {
      dispatch(updateDataComponent('paymentSubmit', { loading: false }));
    }

  }
  const saveData = async (data: any) => {
    try {
      const request: any = {
        "leadId": id,
        "amountReceived": Number(data?.amountReceived),
        "paymentMethod": data?.paymentMethod,
        "transactionReference": data?.transactionReference,
        "notes": data?.notes,
        workOrderId: data?.quatationId,//for payment
        invoiceNumber: data?.invoiceNumber,
        accountCode: ' ',

      }
      if (data?.paymentId) {

        const response: any = await callAPI(`payment-receives`, Method.PUT, request, data.paymentId);
        return response
      } else {
        const response: any = await callAPI("payment-receives", Method.POST, request);
        return response
      }
    } catch (error) {

    }

  }
  return (
    <Grid>
      <Grid container spacing={2} sx={{ marginTop: 0 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="quotationGrid"
            columns={columns}
            title="Quotations"
            data={quotationData}
            gridHeaderSx={{
              backgroundColor: "#E35335",
              border: "1px solid #E35335",
            }}
            addButtonBgClor={{ bg: '#E35335', hovercolor: '#cc4a2f' }}
            isAccordian={true}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleQuotationAddClick}
          />
        </Grid>
          : <PermissionDenied />
        }
        <ConfirmDialog
          open={open}
          title={title}
          onConfirm={onConfirm}
          onClose={handleClose}
        />
        <SwipeableDrawerForm anchor="right" title={'Payments'}
          openForm={openF}
          formComponent={<form onSubmit={handleSubmit(handlePaymentData)}>
            {formComponent}
          </form>}
          onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
        />
      </Grid>
    </Grid>
  );
});
